// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Yh2k","messages":"Chat_messages__1yzaG","dateDivider":"Chat_dateDivider__2GZ4-"};